import { useNavigate } from "react-router-dom";
import styles from "./UpgradeModal.module.css";
import { labels } from "app/settings/organization/roles/RoleListConfiguration";

const UPGRADE_CONTENT = {
  em: {
    title: "You're on the Free plan. Upgrade to unlock full endpoint control.",
    intro:
      "Free covers the basics. Pro adds the compliance, automation, and support tools most IT teams need once they're past a handful of devices.",
    features: [
      {
        label: "Managed devices",
        basic: "Up to 15",
        premium: "Unlimited",
        isText: true,
      },

      { label: "Automated Patch Management", basic: false, premium: true },
      { label: "Vulnerability Management", basic: false, premium: true },
      {
        label: "Advanced Endpoint Control & Security",
        basic: false,
        premium: true,
      },
      {
        label: "Priority support",
        basic: false,
        premium: true,
      },
    ],
  },
  am: {
    title:
      "You're on the Free plan. Upgrade for complete visibility into your IT assets.",
    intro:
      "Free covers essential asset tracking. Standard and Professional add more endpoints, multiple technicians, and the reporting and control tools growing IT teams need.",
    features: [
      {
        label: "Managed endpoints",
        basic: "Up to 25",
        premium: "Unlimited",
        isText: true,
      },
      { label: "Multi-Technician Support", basic: false, premium: true },
      { label: "Role-Based Access Control", basic: false, premium: true },
      { label: "Device Lifecycle Tracking", basic: false, premium: true },
      { label: "Two-Factor Authentication (TFA)", basic: false, premium: true },
    ],
  },
  ra: {
    title:
      "You're on the Free plan. Upgrade for more devices and pro remote tools.",
    intro:
      "Free covers reliable remote access for individuals. Standard and Professional add more managed devices, more concurrent sessions, and the security controls IT teams need.",
    features: [
      {
        label: "Managed devices (Unattended Access)",
        basic: "Up to 25",
        premium: "Unlimited",
        isText: true,
      },
      { label: "Remote Session Recording", basic: false, premium: true },
      { label: "Multi-Monitor Support", basic: false, premium: true },
      { label: "Two-Factor Authentication (TFA)", basic: false, premium: true },
      {
        label: "Diagnostic Troubleshooting Tools",
        basic: false,
        premium: true,
      },
    ],
  },
};

const DEFAULT_CONTENT = UPGRADE_CONTENT.am;

export default function UpgradeModal({
  planName = "Basic",
  upgradeName = "Premium",
  product = "am",
  onClose = () => {},
}) {
  const navigate = useNavigate();
  const content = UPGRADE_CONTENT[product] || DEFAULT_CONTENT;

  const handleClose = () => {
    onClose();
  };

  const handleUpgrade = () => {
    onClose();
    navigate("/app/settings/account/subscription");
  };
  const handleCompare = () => {
    onClose();
    navigate(
      `/app/settings/account/subscription#compare-plans-and-features`,
    );
  };

  return (
    <div className={styles.modal}>
      <div className={styles.header}>
        <span className={styles.badge}>{planName.toUpperCase()} PLAN</span>
        <button
          className={styles.close}
          aria-label="Close"
          onClick={handleClose}
        >
          &times;
        </button>
        <h2 className={styles.title}>{content.title}</h2>
        <div className={styles.bars}>
          <span className={`${styles.bar} ${styles.bar1}`} />
          <span className={`${styles.bar} ${styles.bar2}`} />
          <span className={`${styles.bar} ${styles.bar3}`} />
          <span className={`${styles.bar} ${styles.bar4}`} />
        </div>
      </div>

      <div className={styles.body}>
        <p className={styles.intro}>{content.intro}</p>

        <table className={styles.table}>
          <thead>
            <tr>
              <th>Feature</th>
              <th className={styles.col}>{planName}</th>
              <th className={styles.col}>{upgradeName}</th>
            </tr>
          </thead>
          <tbody>
            {content.features.map((f) => (
              <tr key={f.label}>
                <td>{f.label}</td>
                <td className={`${styles.col} ${styles.muted}`}>
                  {f.isText ? f.basic : f.basic ? "✓" : "–"}
                </td>
                <td className={`${styles.col} ${styles.strong}`}>
                  {f.isText ? f.premium : f.premium ? "✓" : "–"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.footer}>
        {/* <a
          href="https://zecurit.com/pricing"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.compareLink}
        >
          Compare all plans
        </a> */}
        <p onClick={handleCompare} className={styles.compareLink}>
          Compare all plans
        </p>
        <div className={styles.footerActions}>
          <button
            className={`${styles.btn} ${styles.btnSecondary}`}
            onClick={handleClose}
          >
            Maybe later
          </button>
          <button
            className={`${styles.btn} ${styles.btnPrimary}`}
            onClick={handleUpgrade}
          >
            Upgrade
          </button>
        </div>
      </div>
    </div>
  );
}
